<span
  class="company-tree-row__indent"
  [style.flex-basis.px]="indentWidth()"
></span>
@if (showExpandControl()) {
  <button
    type="button"
    class="company-tree-row__expand"
    tabindex="-1"
    aria-hidden="true"
    (click)="onToggle($event)"
  >
    <mat-icon
      class="company-tree-row__chevron"
      [class.company-tree-row__chevron--expanded]="row().expanded"
      svgIcon="chevron-right"
    ></mat-icon>
  </button>
}
<div class="company-tree-row__content">
  <div class="company-tree-row__main">
    <initials-badge [name]="row().name" [size]="30"></initials-badge>
    <div class="company-tree-row__text">
      @if (row().variant === 'root') {
        <div class="company-tree-row__eyebrow">PARENT COMPANY</div>
      }
      <div class="company-tree-row__name">{{ row().name }}</div>
      <div class="company-tree-row__address">{{ displayAddress() }}</div>
    </div>
  </div>
  <div class="company-tree-row__indicator">
    @if (showError()) {
      <span class="company-tree-row__error">{{ row().errorMessage }}</span>
      <button
        type="button"
        class="company-tree-row__retry"
        tabindex="-1"
        (click)="onRetry($event)"
      >
        Retry
      </button>
    } @else if (showSpinner()) {
      <span class="company-tree-row__spinner" aria-hidden="true"></span>
    } @else if (showCheck()) {
      <mat-icon
        class="company-tree-row__check"
        svgIcon="check-filled"
        aria-hidden="true"
      ></mat-icon>
    } @else if (showDot()) {
      <span class="company-tree-row__dot" aria-hidden="true"></span>
    }
  </div>
</div>
